import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import MobileHeader from '~/components/header/Mobile.vue';
import DefaultHeader from '~/components/header/Default.vue';
import NavBar from '@/components/navigation/NavBar.vue';
import SubHeader from '~/components/header/Sub.vue';
import DefaultFooter from '~/components/footer/Default.vue';
import Logo from "~/components/header/Logo.vue";

var Plain = /*#__PURE__*/function (_Vue) {
  _inherits(Plain, _Vue);

  var _super = _createSuper(Plain);

  function Plain() {
    _classCallCheck(this, Plain);

    return _super.apply(this, arguments);
  }

  return Plain;
}(Vue);

Plain = __decorate([Component({
  components: {
    Logo: Logo,
    MobileHeader: MobileHeader,
    DefaultHeader: DefaultHeader,
    NavBar: NavBar,
    SubHeader: SubHeader,
    DefaultFooter: DefaultFooter
  }
})], Plain);
export default Plain;